var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.6V1.34998H0.5V12.15H9",
    stroke: "#474F60"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4.47546,
    width: 5,
    height: 1,
    fill: "#474F60"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6.47546,
    width: 5,
    height: 1,
    fill: "#474F60"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8.47546,
    width: 5,
    height: 1,
    fill: "#474F60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon_information.d4c7e352ebafa699752e11b106c24759.svg";
export { ForwardRef as ReactComponent };